import Device from './Device.vue'

export default Device
